var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80303 0.196083C8.06558 0.457527 8.06558 0.881412 7.80303 1.14286L4.93387 3.99997L7.80309 6.85714C8.06564 7.11859 8.06564 7.54247 7.80309 7.80392C7.54054 8.06536 7.11487 8.06536 6.85232 7.80392L3.9831 4.94675L1.14768 7.77027C0.885129 8.03171 0.459457 8.03171 0.19691 7.77027C-0.0656367 7.50882 -0.0656367 7.08494 0.19691 6.82349L3.03234 3.99997L0.196964 1.17651C-0.0655824 0.915061 -0.0655824 0.491176 0.196964 0.229732C0.459511 -0.0317119 0.885183 -0.0317119 1.14773 0.229732L3.9831 3.0532L6.85227 0.196083C7.11482 -0.0653611 7.54049 -0.0653611 7.80303 0.196083Z",
    fill: "#080808",
    fillOpacity: 0.32
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "close.2e27b1eeb61ac265ded6fd095c16cfc9.svg";